import { createAsyncThunk } from "@reduxjs/toolkit";
import { manageAgreementService } from "./ManageAgreementService";

/**
 * Fetch the agreement detail + attachments for a single contract.
 * Triggered on the Manage Agreement page load.
 */
export const fetchManageAgreement = createAsyncThunk(
  "manageAgreement/fetch",
  async (contractId: string | undefined, thunkAPI) => {
    try {
      const response = await manageAgreementService.fetchManageAgreement(
        contractId,
      );
      if (!response.status) {
        return thunkAPI.rejectWithValue(
          response.message || "Failed to fetch agreement details",
        );
      }
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || "Unknown error");
    }
  },
);
